import React, { useState } from 'react'
import axios from '../../../axios'
import { toast } from 'react-toastify';

function AssessmentDelete({
    setDelete,
    assessmentId,
    getDraftAssessment
}) {

    const [errorText, setErrorText] = useState("");
    let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
    const [isInProgress, setIsInProgress] = useState(false);
    const handleDelete = async () => {
        setIsInProgress(true);
        try {
            let res = await axios.delete(
                `/api/v1/assessment/delete/${assessmentId}`,
                {
                    data: {
                        teacher_id: teacher_id,
                    },
                }
            );
            if (res) {
                toast.success("Assessment Deleted Successfully.")
                getDraftAssessment()
            }
            setDelete(false);
        } catch (error) {
            setIsInProgress(false);
            setErrorText(error.response.data.message)
            console.log(error);
        }
    };


    return (
        <div className="published_Deative_transprant_body">
            <div className="published_Deative_preview_container">
                <img
                    className="deactive_closeBtn"
                    src="/images/cross-circle3.svg"
                    alt=""
                    onClick={(e) => setDelete(false)}
                />
                <div className="col-12 deactivate_msg">
                    Are you sure you want to delete this assessment?
                    {errorText !== "" && <p style={{ color: "red" }}>{errorText}</p>}
                </div>
                <div className="row col-12 publish_deactive_btnBox">
                    <button
                        onClick={handleDelete}
                        disabled={isInProgress}
                        className="btn col-sm-5 my-1 deactive_sure_btn"
                    >
                        Yes
                    </button>
                    <button
                        disabled={isInProgress}
                        className="btn col-sm-5 my-1 deactive_sure_btn"
                        onClick={(e) => setDelete(false)}
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AssessmentDelete